import { ChangeEvent, FC } from 'react';

import { Option } from '@pickles/shared/models/general.types';

import { Select } from './style';
import FieldHint from '../FieldHint';

interface DropdownSelectProps {
  name: string;
  options: Option<string>[];
  placeholder?: string;
  onChange: (e: ChangeEvent) => void;
  error?: string;
  selectedValue?: string;
}

const DropdownSelect: FC<DropdownSelectProps> = ({
  name,
  options,
  placeholder,
  onChange,
  error,
  selectedValue,
}) => {
  return (
    <>
      <Select
        name={name}
        id={name}
        onChange={onChange}
        error={!!error}
        isSelected={!!selectedValue}
        value={selectedValue || 'default'}
      >
        {placeholder && (
          <option key={'default'} value={'default'} disabled={!!selectedValue}>
            {placeholder}
          </option>
        )}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Select>
      {error && <FieldHint error={true} message={error} />}
    </>
  );
};

export default DropdownSelect;
